import { BucketName } from './asset.model';

export const UploadStatus = {
  Pending: 'pending',
  Uploading: 'uploading',
  Completed: 'completed',
  Failed: 'failed',
  Cancelled: 'cancelled',
} as const;

export type UploadStatus = (typeof UploadStatus)[keyof typeof UploadStatus];

export interface UploadMediaItem {
  id?: number;
  file: File;
  metadata: {
    id?: string;
    userId?: string;
    fileName: string;
    fileType: string;
    objectName: string;
    bucketName: BucketName;
  };
  uploaded?: boolean;
  status?: UploadStatus;
  progress?: number;
  retryCount?: number;
  maxRetries?: number;
  errorMessage?: string;
  addedAt?: number;
  fileSize?: number;
  batchId?: string;
}

export interface UploadBatch {
  id: string;
  totalFiles: number;
  completedFiles: number;
  failedFiles: number;
  totalBytes: number;
  uploadedBytes: number;
  startedAt: number;
  bucketName: BucketName;
  memoryId?: string;
}

export interface UploadConstraints {
  maxFileCount: number;
  maxBatchSizeBytes: number;
  maxImageSizeBytes: number;
  maxVideoSizeBytes: number;
  allowedImageTypes: string[];
  allowedVideoTypes: string[];
}

export const DEFAULT_UPLOAD_CONSTRAINTS: UploadConstraints = {
  maxFileCount: 30,
  maxBatchSizeBytes: 1024 * 1024 * 1024, // 1 GB
  maxImageSizeBytes: 50 * 1024 * 1024, // 50 MB
  maxVideoSizeBytes: 500 * 1024 * 1024, // 500 MB
  allowedImageTypes: ['image/jpeg', 'image/png', 'image/heic', 'image/heif', 'image/webp'],
  allowedVideoTypes: ['video/mp4', 'video/quicktime', 'video/webm', 'video/mov'],
};

export interface UploadValidationError {
  file?: File;
  message: string;
}
